import { Direction } from '@/store/types';

export const RRP_SYK_PREFIX = 'rrpSyk';
export const IGENTIFY_LOGO_SRC = '/ui-assets/igentify/igentify_logo.svg';
export const DEFAULT_DIRECTION = Direction.LTR;
export const DEFAULT_LOCALE = 'en';
